import { mstrService } from '@/projects/platform/services/mstr-service';
import MstrWrapper from '@/core/wrappers/mstr-wrapper';

export default function MstrStockDashboards() {
    return (<MstrWrapper getReport={mstrService.getStockReport} />);
}